import { joinStrings } from "@/lib/joinString"
import { cn } from "@/lib/utils"
import type { BetterDocCareProviderSearchItem } from "@/modules/patients/detail/better-doc/de/services/betterDocCareProviderSearchQuery"

type BetterDocPreferredCareProviderSummaryProps = {
  careProvider: BetterDocCareProviderSearchItem
}

export const BetterDocPreferredCareProviderSummary = ({ careProvider }: BetterDocPreferredCareProviderSummaryProps) => {
  const { medicName, workplaceName, street, postalCode, city } = careProvider
  const addressLine = joinStrings([street, joinStrings([postalCode, city], " ")], ", ")

  return (
    <span className="flex min-w-0 flex-col">
      {medicName ? <span className="text-on-surface truncate text-sm">{medicName}</span> : null}
      <span className={cn("truncate", medicName ? "text-on-surface-subdued text-xs" : "text-on-surface text-sm")}>
        {workplaceName}
      </span>
      {addressLine ? <span className="text-on-surface-subdued truncate text-xs">{addressLine}</span> : null}
    </span>
  )
}
